import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

/* eslint-disable no-nested-ternary */
export function DropdownFilter({
  filterKey,
  filterValue,
  data,
  onChange,
  multiple = false,
  hasAny,
  defaultValue,
  fullWidth = false,
  disabled = false,
  dropdownId = undefined,
}) {
  function handleChange(event) {
    const selectedValues = event.target.value;

    const filteredValues = multiple
      ? selectedValues.length === 0 || selectedValues[selectedValues.length - 1] === ''
        ? ''
        : selectedValues.filter(x => x !== '')
      : selectedValues;
    onChange(filterKey, filteredValues);
  }

  return (
    <Select
      id={dropdownId}
      multiple={multiple}
      disabled={disabled}
      value={filterValue || defaultValue}
      onChange={e => handleChange(e)}
      fullWidth={fullWidth}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      }}
    >
      {hasAny && <MenuItem value="">Any</MenuItem>}
      {data &&
        data.map(({ name, id }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
    </Select>
  );
}
